import { useNavigate } from 'react-router-dom';

const galleryPhotos = [
  'https://storage.readdy-site.link/project_files/0c67b98a-5efe-4a8e-a1fa-e6ce09f7829e/68a63646-0b23-467d-9d98-852bb8ff13ec_Steel-Rebar-Container-Loading-8-1024x768.jpg?v=695878cdde7298dc1df7006d2e3344a0',
  'https://storage.readdy-site.link/project_files/0c67b98a-5efe-4a8e-a1fa-e6ce09f7829e/330461ce-a66c-4ad5-b010-0873b379f36f_Steel-Rebar-Container-Loading-7-1024x768.jpg?v=e9090c2268431b467684432ce21ec585',
  'https://storage.readdy-site.link/project_files/0c67b98a-5efe-4a8e-a1fa-e6ce09f7829e/89c71f78-1541-4cc7-8181-1e34a19f323b_Steel-Rebar-Container-Loading-13-768x1024.jpg?v=19ee20e462349fecf5ab88109bb2e338',
  'https://storage.readdy-site.link/project_files/0c67b98a-5efe-4a8e-a1fa-e6ce09f7829e/00d496aa-12e5-4f07-9ea3-3bc68f5a3c6a_Steel-Rebar-Container-Loading-12-768x1024.jpg?v=0ea2c4eb9d78b12bd3f2ee7b2f5a11d4',
];

const stats = [
  { value: '26 MT', label: 'Rebar Shipped' },
  { value: '18 Days', label: 'Lead Time' },
  { value: 'FOB GZ', label: 'Incoterms' },
  { value: '10 Photos', label: 'Documented' },
];

export default function CaseStudyBanner() {
  const navigate = useNavigate();

  return (
    <section className="py-20 bg-white">
      <div className="max-w-[1420px] mx-auto px-6">

        {/* Label */}
        <div className="text-center mb-10">
          <span className="text-xs font-black tracking-widest uppercase" style={{ color: '#1e5fa8' }}>Real Order. Real Photos.</span>
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mt-2 mb-3">See It Happen — A Live Sourcing Case</h2>
          <p className="text-gray-500 text-sm max-w-xl mx-auto">
            We documented an entire rebar shipment from mill inspection to container sealing. Every step, every photo — so you know exactly what to expect.
          </p>
        </div>

        {/* Card */}
        <div
          className="rounded-2xl overflow-hidden border border-gray-100 cursor-pointer group"
          onClick={() => navigate('/sourcing-case')}
          style={{ backgroundColor: '#f7f9fc' }}
        >
          <div className="grid grid-cols-1 lg:grid-cols-2">

            {/* Left — photo grid */}
            <div className="grid grid-cols-2 gap-1 p-1">
              {galleryPhotos.map((url, idx) => (
                <div key={idx} className="overflow-hidden aspect-[4/3]">
                  <img
                    src={url}
                    alt={`Loading step ${idx + 1}`}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
              ))}
            </div>

            {/* Right — content */}
            <div className="flex flex-col justify-between p-8 lg:p-12">
              <div>
                {/* Tag */}
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-bold mb-6 text-white" style={{ backgroundColor: '#0a2342' }}>
                  <span className="w-1.5 h-1.5 rounded-full bg-green-400 animate-pulse" />
                  Verified Shipment — Foshan, China
                </div>

                <h3 className="text-2xl font-black text-gray-900 mb-3 leading-snug">
                  Steel Rebar HRB400<br />
                  <span className="text-gray-400 font-semibold text-lg">Container Loading, Step by Step</span>
                </h3>

                <p className="text-gray-500 text-sm leading-relaxed mb-6">
                  26 metric tons of HRB400 rebar, sourced from a certified Foshan mill and shipped FOB Guangzhou to West Africa. We were on-site for every stage — inspection, loading, sealing, and documentation.
                </p>

                {/* Stats row */}
                <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-2 xl:grid-cols-4 gap-3 mb-8">
                  {stats.map((s) => (
                    <div key={s.label} className="bg-white rounded-xl p-3 border border-gray-100 text-center">
                      <p className="text-base font-black text-gray-900">{s.value}</p>
                      <p className="text-xs text-gray-400 mt-0.5">{s.label}</p>
                    </div>
                  ))}
                </div>

                {/* Steps preview */}
                <div className="space-y-2 mb-8">
                  {[
                    'Container arrival & seal verification',
                    'Mill test certificate check on-site',
                    'Physical measurement & weight confirmation',
                    'Loading, sealing & full documentation',
                  ].map((step, i) => (
                    <div key={i} className="flex items-center gap-3 text-sm text-gray-600">
                      <div className="w-5 h-5 flex items-center justify-center rounded-full flex-shrink-0 text-white text-xs font-black" style={{ backgroundColor: '#0a2342' }}>
                        {i + 1}
                      </div>
                      {step}
                    </div>
                  ))}
                </div>
              </div>

              {/* CTA */}
              <div className="flex flex-col sm:flex-row gap-3">
                <button
                  onClick={(e) => { e.stopPropagation(); navigate('/sourcing-case'); }}
                  className="flex items-center justify-center gap-2 px-6 py-3.5 text-white font-black text-sm rounded-lg transition-all whitespace-nowrap group-hover:opacity-90"
                  style={{ backgroundColor: '#0a2342' }}
                >
                  <i className="ri-image-2-line" />
                  View All 10 Photos
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </button>
                <a
                  href="https://wa.me/8617671262710"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()}
                  className="flex items-center justify-center gap-2 px-6 py-3.5 bg-green-500 hover:bg-green-600 text-white font-black text-sm rounded-lg transition-all whitespace-nowrap"
                >
                  <i className="ri-whatsapp-line" />
                  Order Same Product
                </a>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
